import type { RouteRecordRaw } from 'vue-router';

const tdriveRoutes: RouteRecordRaw[] = [
    {
        path: '/tdrive',
        name: 'TDriveMain',
        component: () => import('./views/TDriveMainPage.vue'),
        meta: {
            title: 'T-Drive',
            requiresAuth: true,
            layout: 'default',
        },
    },
];

// default export로도 제공 (라우터 자동 로딩 지원)
export default tdriveRoutes;

// named export도 유지 (다른 곳에서 사용할 수 있도록)
export { tdriveRoutes };

